import { useMutation, gql } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';

import { GET_PROCESS_BY_ID } from 'src/hooks/processes/get-process-by-id.hook';
import { GET_PROCESSES_WITH_PAGINATION } from 'src/hooks/processes/get-processes-with-pagination.hook';
import { GET_PROCESS_TASKS_TEMPLATES_FOR_TABLE } from './get-process-tasks-templates.hook';

import { IHookCallbacks } from '../common.hooks.interfaces';


export const CREATE_PROCESS_TASKS_TEMPLATE = gql`
  mutation createProcessTasksTemplate($payload: CreateProcessTaskTemplateInput!) {
    createProcessTasksTemplate(payload: $payload) {
      _id
    }
  }
`;

export const useCreateProcessTasksTemplate = ({ onSuccess }: IHookCallbacks) => {
  const { t } = useTranslation('settings');
  const [createProcessTasksTemplate, { loading }] = useMutation(CREATE_PROCESS_TASKS_TEMPLATE, {
    onCompleted: data => {
      if (data?.createProcessTasksTemplate?._id) {
        showNotification({
          isIcon: false,
          type: NOTIFICATION_TYPE.success,
          message: t('processTemplates.notifications.created'),
        });
        if (onSuccess) {
          onSuccess();
        }
      }
    },
    refetchQueries: [GET_PROCESSES_WITH_PAGINATION, GET_PROCESS_BY_ID, GET_PROCESS_TASKS_TEMPLATES_FOR_TABLE],
  });

  return { createProcessTasksTemplate, loading };
};
